import { Component, OnInit } from '@angular/core';
import { SaPaypalServiceService } from '../../services/SaPaypalService.service';
import { Router } from '@angular/router';
import { LicenseDataService } from '../../services/LicenseData.service';
import { TransactionsModal } from './TransactionsModal';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ips-transaction-history',
  templateUrl: './ips-transaction-history.component.html',
  styleUrls: ['./ips-transaction-history.component.css']
})
export class IpsTransactionHistoryComponent implements OnInit {
  searchTermIpsTransaction: string = ''
  ipsTransactions: TransactionsModal[] = [];
  showOverlaySmallloadips: boolean = false;
  transactionPageNo: number = 1;
  invoiceDetailsGetHtml: string;
  mainViewError = new ErrorModel();

  constructor(private service: SaPaypalServiceService, private Lic_service: LicenseDataService, private router: Router) { }

  ngOnInit() {
    this.searchTermIpsTransaction = '';
    this.transactionPageNo = 1;
    this.getIpsTransactions(this.searchTermIpsTransaction);
  }


  getIpsTransactions(searchTermIpsTransaction) {

    this.searchTermIpsTransaction = searchTermIpsTransaction;
    this.showOverlaySmallloadips = true;
    this.mainViewError.display = false;
    this.service.getIpsTransactionss(1, this.searchTermIpsTransaction).subscribe(
    (data: TransactionsModal[]) => {
    this.ipsTransactions = [];

      this.ipsTransactions = data;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlaySmallloadips = false;
    });
  }

  onScrollGetIpsTransactions() {
    this.showOverlaySmallloadips = true;
    this.transactionPageNo++;
    this.service.getIpsTransactionss(this.transactionPageNo, this.searchTermIpsTransaction).subscribe(
    (data: TransactionsModal[]) => {
      const transcation = data;
      transcation.forEach(i => {
        this.ipsTransactions.push(i);
      });
    }).add(() => {
      this.showOverlaySmallloadips = false;
    });
  }

  getInvoice(InvoiceNo, SaId) {
    this.invoiceDetailsGetHtml = null;
    this.Lic_service.getSingleInvoiceInHtml(InvoiceNo, SaId).subscribe(
    (data) => {
      this.invoiceDetailsGetHtml = data as string;
      let newWindow = window.open('', 'newWindow', 'resizable=yes');
      newWindow.document.write(this.invoiceDetailsGetHtml);
      newWindow.document.close();
    });
  }
}
